/** PRODUCTION **/
export const SERVICE_PREFIX = "http://api.alacuenta.com:25102";